export default __webpack_public_path__ + "static/media/levelUp.5a128ec3.png";